import { render, staticRenderFns } from "./job-posting.vue?vue&type=template&id=e6c7b678&scoped=true"
import script from "./job-posting.vue?vue&type=script&lang=js"
export * from "./job-posting.vue?vue&type=script&lang=js"
import style0 from "./job-posting.vue?vue&type=style&index=0&id=e6c7b678&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c7b678",
  null
  
)

export default component.exports